module.exports = __webpack_public_path__ + "img/brand-icon.61180b63.webp";